<p-dialog
    [(visible)]="visible"
    [header]="title | translate"
>
    <div class="grid-2col input-grid-gaps">
        <app-text-input
            [form]="form"
            id="name"
            label="service.nursingCareDiagnosisGroup.fields.name"
            class="fr-2"
        ></app-text-input>
        <app-check-input
            [form]="form"
            id="active"
            label="service.nursingCareDiagnosisGroup.fields.active"
            class="fr-2"
        ></app-check-input>
    </div>

    <ng-template #footer>
        <app-action-buttons (primaryClickEvent)="submit()" (secondaryClickEvent)="show(false)">
            @if (group) {
                <app-delete-button (clickEvent)="delete()"></app-delete-button>
            }
        </app-action-buttons>
    </ng-template>
</p-dialog>
